import React, {useEffect, useState} from "react";
import {Card} from "react-bootstrap";
import {collection, getDocs, limit, orderBy, query} from "@firebase/firestore";
import {db} from "../../../firebase/FirebaseProvider";
import {Timestamp} from "firebase/firestore";
import {logDataLoaded} from "../../util/Util";

interface ExternalNews {
    id: string;
    title: string;
    link: string;
    pubDate: Timestamp;
    source: string;
    fetchedAt: Timestamp;
}

function NewsHeadlinesWidget() {
    const [newsItems, setNewsItems] = useState<Array<ExternalNews>>([]);
    const [loading, setLoading] = useState<boolean>(true);

    useEffect(() => {
        (async () => {
            await loadNews();
        })();
    }, []);

    const loadNews = async() => {
        try {
            let news: Array<ExternalNews> = [];
            const newsCollection = query(
                collection(db, 'external-news'),
                orderBy('fetchedAt', 'desc'),
                limit(5)
            );
            const newsSnapshot = await getDocs(newsCollection);
            newsSnapshot.forEach((doc) => {
                const newsItem = doc.data() as ExternalNews;
                newsItem.id = doc.id;
                news.push(newsItem);
            });
            logDataLoaded('external news', news.length);
            setNewsItems(news);
        } catch (error) {
            console.error("Error loading news:", error);
        } finally {
            setLoading(false);
        }
    };

    if (loading) {
        return (
            <Card className={"mb-3"}>
                <Card.Header>
                    <div><b>Latest News</b></div>
                </Card.Header>
                <Card.Body style={{padding: "1em"}}>
                    <div className={'loading'}>Loading...</div>
                </Card.Body>
            </Card>
        );
    }

    if (newsItems.length === 0) {
        return null;
    }

    return (
        <Card className={"mb-3"}>
            <Card.Header>
                <div><b>Latest News</b></div>
            </Card.Header>
            <Card.Body style={{padding: "1em"}}>
                <ul style={{marginBottom: 0, paddingLeft: "0rem", listStyle: "none"}}>
                    {newsItems.map((item, index) => {
                        // Extract headline and source from title
                        const lastDashIndex = item.title.lastIndexOf(' - ');
                        const headline = lastDashIndex !== -1 ? item.title.substring(0, lastDashIndex) : item.title;
                        const source = lastDashIndex !== -1 ? item.title.substring(lastDashIndex + 3) : item.source;
                        
                        return (
                            <li key={item.id} style={{
                                paddingBottom: index < newsItems.length - 1 ? "0.8rem" : "0",
                                marginBottom: index < newsItems.length - 1 ? "0.8rem" : "0",
                                borderBottom: index < newsItems.length - 1 ? "1px solid grey" : "none"
                            }}>
                                <div>
                                    <div style={{fontSize: "0.95rem", lineHeight: "1.5"}}>
                                        <a href={item.link} target="_blank" rel="noopener noreferrer" style={{color: "white"}}>
                                            {headline}
                                        </a>
                                    </div>
                                    <div style={{fontSize: "0.8rem", color: "#999", marginTop: "0.2rem"}}>
                                        {source}
                                    </div>
                                </div>
                            </li>
                        );
                    })}
                </ul>
            </Card.Body>
        </Card>
    );
}

export default NewsHeadlinesWidget;